import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';

/**
 * Recherche libre d'une barre d'outils.
 *
 * Le composant ne connaît que la frappe : c'est le panneau qui en espace les effets et
 * décide du paramètre envoyé. Il occupe la largeur restante, comme sur la maquette.
 *
 * `placeholderKey` permet à un écran de dire ce qu'on y cherche : le libellé par défaut
 * parle d'équipements, ce qui serait faux ailleurs que dans la création d'intervention.
 */
export default function TableSearch({
  value,
  onChange,
  placeholderKey = 'interventionCreation.filters.searchPlaceholder'
}: {
  value: string;
  onChange: (value: string) => void;
  placeholderKey?: string;
}) {
  const { t } = useTranslation();

  return (
    <TextField
      size="small"
      fullWidth
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={t(placeholderKey)}
      inputProps={{ 'aria-label': t('interventionCreation.filters.search') }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        // Arrondi en pilule : la maquette distingue ainsi la recherche des listes
        // déroulantes voisines, qui gardent le rayon des champs.
        sx: { borderRadius: 999 }
      }}
    />
  );
}
